import { isAxiosError } from "axios";

import {
  ApiErrorEnvelopeReadSchema,
  type ApiErrorEnvelopeRead,
} from "@shared/schemas/api-error-envelope.schemas";

// eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- catch blocks receive unknown type by design
function parseApiErrorEnvelope(error: unknown): ApiErrorEnvelopeRead | null {
  if (!isAxiosError(error)) {
    return null;
  }
  const parsed = ApiErrorEnvelopeReadSchema.safeParse(error.response?.data);
  return parsed.success ? parsed.data : null;
}

// eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- catch blocks receive unknown type by design
export function extractApiErrorCode(error: unknown): string | null {
  return parseApiErrorEnvelope(error)?.code ?? null;
}

// eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- catch blocks receive unknown type by design
export function extractBackendMessage(error: unknown): string | null {
  return parseApiErrorEnvelope(error)?.message ?? null;
}

/* eslint-disable planta-v2/unknown-only-at-boundaries -- catch blocks receive unknown type by design */
export function extractApiErrorData(
  error: unknown,
): Record<string, unknown> | null {
  /* eslint-enable planta-v2/unknown-only-at-boundaries */
  return parseApiErrorEnvelope(error)?.data ?? null;
}

// eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- catch blocks receive unknown type by design
export function normalizeError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  return new Error(typeof error === "string" ? error : String(error));
}
